import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.extra.space.Record.Anomaly,
    graphql.schema.Anomaly
  >({
    [ents.extra.space.Record.Anomaly.IncorrectDoorNumber]:
      graphql.schema.Anomaly.IncorrectDoorNumber,
    [ents.extra.space.Record.Anomaly.IncorrectFloorPlan]:
      graphql.schema.Anomaly.IncorrectFloorPlan,
    [ents.extra.space.Record.Anomaly.RoomDoesNotExists]:
      graphql.schema.Anomaly.RoomDoesNotExists,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.Anomaly,
    ents.extra.space.Record.Anomaly
  >({
    [graphql.schema.Anomaly.IncorrectDoorNumber]:
      ents.extra.space.Record.Anomaly.IncorrectDoorNumber,
    [graphql.schema.Anomaly.IncorrectFloorPlan]:
      ents.extra.space.Record.Anomaly.IncorrectFloorPlan,
    [graphql.schema.Anomaly.RoomDoesNotExists]:
      ents.extra.space.Record.Anomaly.RoomDoesNotExists,
  }),
)
